var udundi = angular.module('udundi', ['ngAnimate', 'masonry', 'ui.directives', 'ui.filters', 'ui.bootstrap', 'ui-rangeSlider']);

udundi.config(function($interpolateProvider){
  $interpolateProvider.startSymbol('{[').endSymbol(']}');
});

udundi.controller('ShopController', ['$scope', '$http', function ($scope, $http) {
  $http.get('/products.json?limit=250').success(function(data) {

    $scope.products = products;
    $scope.order = 'title';
    $scope.setOrder = function(order) {
      $scope.order = order;
    };
    
{{ collection.handle }}

    $scope.variants = [];
    angular.forEach($scope.products, function(product) {
      angular.forEach(product.variants, function(variants) {
        if ($scope.variants.indexOf(variants) === -1) {
          $scope.variants.push(variants);
        }
      });
    });

    $scope.search = {
      variants: {}
    };
    $scope.explore = {
      variants: {}
    };
    $scope.hunt = {
      variants: {}
    };

    $scope.sliderRanges = {
      priceMin: 0,
      priceMax: 250,
      min:  0,
      max:  250,
      step: 10
    };

    $scope.filter = {};
    $scope.vendorFilter = function (item) {
      return $scope.filter[item.vendor] || noFilter($scope.filter);
    };

    function noFilter(filterObj) {
        for (var key in filterObj) {
            if (filterObj[key]) {
                return false;
            }
        }
        return true;
    }
  });
}]);

udundi.filter('capitalize', function() {
  return function(input, scope) {
    return input.substring(0,1).toUpperCase()+input.substring(1);
  }
});

udundi.filter('optionOneFilter', function($filter) {
    var helper = function(checklist, item, listName, search) {
        var count = 0;
        var result = false;
        angular.forEach(checklist, function(checked, checkboxName) {
            if (checked) {
                count++;
                var obj = {};
                obj[search] = checkboxName;
                result = result || ($filter('filter')(item[listName], obj, true).length > 0);
            }
        });
        return (count === 0) || result;
    };

    return function(input, definition) {
        var result = [];

        if (angular.isArray(input) && angular.isObject(definition)) {
            angular.forEach(input, function(item) {
                var matched = null;
                angular.forEach(definition, function(checklist, listName) {
                    var tmp;
                    if (listName == 'products') {
                      tmp = helper(checklist, item, listName, 'vendor');
                    } else {
                      tmp = helper(checklist, item, listName, 'option1');
                    }
                      matched = (matched === null) ? tmp : matched && tmp;
                });
                if (matched) result.push(item);
            });
        }
        return result;
    };
});

udundi.filter('optionTwoFilter', function($filter) {
    var helper = function(checklist, item, listName, explore) {
        var count = 0;
        var result = false;
        angular.forEach(checklist, function(checked, checkboxName) {
            if (checked) {
                count++;
                var obj = {};
                obj[explore] = checkboxName;
                result = result || ($filter('filter')(item[listName], obj, true).length > 0);
            }
        });
        return (count === 0) || result;
    };

    return function(input, definition) {
        var result = [];

        if (angular.isArray(input) && angular.isObject(definition)) {
            angular.forEach(input, function(item) {
                var matched = null;
                angular.forEach(definition, function(checklist, listName) {
                    var tmp;
                    tmp = helper(checklist, item, listName, 'option2');
                    matched = (matched === null) ? tmp : matched && tmp;
                });
                if (matched) result.push(item);
            });
        }
        return result;
    };
});

udundi.filter('optionThreeFilter', function($filter) {
    var helper = function(checklist, item, listName, hunt) {
        var count = 0;
        var result = false;
        angular.forEach(checklist, function(checked, checkboxName) {
            if (checked) {
                count++;
                var obj = {};
                obj[hunt] = checkboxName;
                result = result || ($filter('filter')(item[listName], obj, true).length > 0);
            }
        });
        return (count === 0) || result;
    };

    return function(input, definition) {
        var result = [];

        if (angular.isArray(input) && angular.isObject(definition)) {
            angular.forEach(input, function(item) {
                var matched = null;
                angular.forEach(definition, function(checklist, listName) {
                    var tmp;
                    tmp = helper(checklist, item, listName, 'option3');
                    matched = (matched === null) ? tmp : matched && tmp;
                });
                if (matched) result.push(item);
            });
        }
        return result;
    };
});

udundi.filter('rangeFilter', function() {
  return function(products, sliderRanges) {
    
    var filtered = [];
    var priceMin = parseInt(sliderRanges.priceMin);
    var priceMax = parseInt(sliderRanges.priceMax);

    angular.forEach(products, function(product) {
      var price = (product.price)/100;
      if((price >= priceMin && price <= priceMax)) {
        filtered.push(product);
      }
    });
    
    return filtered;
  };
});